import { render, staticRenderFns } from "./ViewPaymentPage.vue?vue&type=template&id=ffd69cc2&"
import script from "./ViewPaymentPage.vue?vue&type=script&lang=js&"
export * from "./ViewPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports